module.exports = __webpack_public_path__ + "static/media/checkbox_filled_black.72107077.svg";